<template>
  <header class="navbar-top">
    <span>金額明細</span>
  </header>

  <section class="content">
    <div class="table-responsive">
      <table class="table">
        <thead>
          <tr>
            <th scope="col">#</th>
            <th scope="col">商品名稱</th>
            <th scope="col">總價格</th>
            <th scope="col">備註</th>
          </tr>
        </thead>
        <tbody></tbody>
      </table>
    </div>
  </section>
  <footer class="footer"></footer>
</template>
